import axios from 'axios';

// Define dateString in the proper scope
const dateString = new Date().toISOString().split('T')[0];

export async function getBuildings() {
  const response = await axios.get(`/api/v1/buildings`);
  return response.data;
}

export async function getBuildingNameById(id) {
  const response = await axios.get(`/api/v1/building/${id}/name`);
  return response.data;
}

export async function getBuilding(id) {
  const response = await axios.get(`/api/v1/building/${id}`);
  return response.data;
}

export async function updateBuilding(id, data) {
  const response = await axios.put(`/api/v1/building/${id}`, data);
  return response.data;
}

export async function getLatestWeather(id) {
  const response = await axios.get(
    `/api/v1/building/${id}/weather/day/${dateString}`
  );
  return response;
}

export async function createBuilding(data) {
  const response = await axios.post('/api/v1/building', data);
  return response.data;
}

export async function getDevicesByBuilding(id) {
  const response = await axios.get(`/api/v1/building/${id}/devices`);
  return response.data;
}

export async function getEosSourceByBuilding(id) {
  const res = await axios.get(`/api/v1/building/${id}/eosSource`);
  return res.data;
}

export async function getEosSensorData() {
  const res = await axios.get(`/api/v1/eos/getEosSensorData`);
  return res.data;
}

export async function getOverviewDevices() {
  try {
    const res = await axios.get('/api/v1/overview/devices');
    return res.data;
  } catch (err) {
    console.error('Error fetching overview devices:', err);
    return { devices: [], eosDevices: [] };
  }
}

export async function getBuildingConsumptionMonthlyPerBuilding(buildingIds) {
  const response = await axios.get(
    '/api/v1/buildings/co2-consumption-monthly-per-building',
    {
      params: {
        buildingIds: buildingIds,
      },
    }
  );
  return response.data;
}

export async function getExchangeRates() {
  try {
    const response = await axios.get('/api/v1/exchange-rates');
    return response.data;
  } catch (error) {
    console.error('Error fetching exchange rates:', error);
    return null;
  }
}

export async function getZoneAveragesOnBuilding(id) {
  const response = await axios.get(`/api/v1/building/${id}/averagereadings`);
  return response.data;
}

export async function getZoneWarningsOnBuilding(id) {
  const response = await axios.get(`/api/v1/building/${id}/zone-warnings`);
  return response.data;
}

export async function getZoneWarningLog(id, { from, to } = {}) {
  const params = {};
  if (from) params.from = from.toISOString();
  if (to) params.to = to.toISOString();
  const response = await axios.get(`/api/v1/building/${id}/zone-warnings/log`, {
    params,
  });
  return response.data;
}

export async function getAggregatedConsumptionForPeriod(
  buildingIds,
  startDate,
  endDate
) {
  const response = await axios.get(
    '/api/v1/buildings/aggregated-consumption-for-period',
    {
      params: {
        buildingIds,
        startDate,
        endDate,
      },
    }
  );
  return response.data;
}

export async function getAggregatedEosReadingsForPeriod(
  buildingIds,
  eosDeviceId,
  startDate,
  endDate
) {
  const response = await axios.get(
    '/api/v1/buildings/aggregated-hourly-consumption-for-period',
    {
      params: {
        buildingIds,
        eosDeviceId,
        startDate,
        endDate,
      },
    }
  );
  return response.data;
}

export async function getAggregatedTotalConsumptionForPeriod(
  buildingIds,
  eosDeviceId,
  startDate,
  endDate
) {
  const response = await axios.get(
    '/api/v1/buildings/aggregated-total-consumption-per-category-for-period',
    {
      params: {
        buildingIds,
        eosDeviceId,
        startDate,
        endDate,
      },
    }
  );
  return response.data;
}

export async function getConsumptionComparisonForBuildings(buildingIds) {
  const response = await axios.get(
    '/api/v1/buildings/consumption-comparison-for-building',
    {
      params: {
        buildingIds: buildingIds,
      },
    }
  );
  return response.data;
}

export async function getConsumptionComparisonWithPriceForBuildings(
  buildingIds
) {
  const response = await axios.get(
    '/api/v1/buildings/consumption-comparison-with-price-for-building',
    {
      params: {
        buildingIds: buildingIds,
      },
    }
  );
  return response.data;
}
